import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const getServiceChartData = (apiResponse) => {
  const colors = [
    "rgba(99,102,241,0.8)",
    "rgba(139,92,246,0.8)",
    "rgba(20,184,166,0.8)",
    "rgba(245,159,0,0.8)",
    "rgba(236,72,153,0.8)",
    "rgba(34,197,94,0.8)",
  ];

  return {
    categories: apiResponse?.data?.map((item) => item.product) || [],
    data:
      apiResponse?.data?.map((item, index) => ({
        y: Number(item.amount.replace(/[$,]/g, "")) || 0,
        color: colors[index % colors.length],
      })) || [],
    expectedAmount:
      Number(apiResponse?.expected_amount?.replace(/[$,]/g, "")) || 0,
  };
};

const ServiceBarChart = ({ chartData, apiLoading, height = 300 }) => {
  chartData = getServiceChartData(chartData);
  const serviceChartOptions = {
    chart: {
      type: "bar",
      backgroundColor: "transparent",
      height: height,
    },

    title: { text: "" },

    xAxis: {
      categories: chartData?.categories || [],
      lineWidth: 0,
      tickWidth: 0,
      gridLineWidth: 0,
      labels: {
        style: {
          color: "#6B7280",
          fontSize: "12px",
        },
      },
    },

    yAxis: {
      title: { text: "" },
      gridLineColor: "#E5E7EB",
      gridLineDashStyle: "Solid",
      labels: {
        style: {
          color: "#6B7280",
          fontSize: "12px",
        },
        formatter: function () {
          return "$" + this.value / 1000 + "K";
        },
      },
    },

    legend: { enabled: false },

    tooltip: {
      backgroundColor: "#ffffff",
      borderColor: "#E5E7EB",
      borderRadius: 8,
      shadow: true,
      formatter: function () {
        // use this.point.category instead of this.x
        return `<b>${this.point.category}</b><br/>$${this.y.toLocaleString()}`;
      },
    },

    plotOptions: {
      bar: {
        borderRadius: 5,
        pointPadding: 0.15,
        groupPadding: 0.1,
        dataLabels: {
          enabled: false,
        },
      },
      series: {
        colorByPoint: true,
      },
    },

    series: [
      {
        name: "Services",
        data: chartData?.data || [],
      },
    ],

    credits: { enabled: false },
  };

  return (
    <HighchartsReact highcharts={Highcharts} options={serviceChartOptions} />
  );
};

export default ServiceBarChart;
